export const SEPARATOR = 0;
